import React, {useState} from 'react'



export default function TextForm(props) {

    const convert = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to uppercase", "Success");
    }
    const convertLower = () => {
        let newText2 = text.toLowerCase();
        setText(newText2);
        props.showAlert("Converted to lowercase", "Success");
    }
    const capitalize = () => {
        let newText4 = text.split(" ").map((word) => { 
            return word[0].toUpperCase() + word.slice(1); 
        }).join(" ");
        setText(newText4);
        props.showAlert("Capitalized Successed", "Success");
    }
    const clearText = () => {
        let newText3 = '';
        setText(newText3);
    }
    const copyText = () => {
        let newText5 = document.getElementById("myBox");
        newText5.select();
        navigator.clipboard.writeText(newText5.value);
        document.getSelection().removeAllRanges();
        props.showAlert("Text Copy Successfully", "Success");
    }
    const removeSpace = () => {
        let newText6 = text.split(/[ ]+/);
        setText(newText6.join(" "));
        props.showAlert("Extra Spaces Remove Successful", "Success");
        
    }
    const change = (event) => {
        setText(event.target.value)
    }


    const [text, setText] = useState('')
    return (
        <>
        <div className='container' style={{color:props.mode==='dark'?'white':'#042743'}}>
            <h1>{props.heading}</h1>
            <div className="mb-3">
            <textarea className="form-control" value={text} onChange={change} style={{backgroundColor:props.mode==='dark'?'rgb(14 43 66)':'white', color:props.mode==='dark'?'white':'#042743' }} id="myBox" rows="8"></textarea>
            </div>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={convert}>Convert to upper case</button>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={convertLower}>Convert to lower case</button>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={capitalize}>Capitalize</button>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={clearText}>Clear</button>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={copyText}>Copy Text</button>
            <button disabled={text.length===0} type='button' className="btn btn-primary mx-2 my-2" onClick={removeSpace}>Remove Extra Spaces</button>
        </div>
        <div className="container my-3" style={{color:props.mode==='dark'?'white':'#042743'}}>
            <h1>Text Summary</h1>
            <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words and {text.length} Characters </p>
            <h3>Enter text above will preview below</h3>
            <div>{text}</div>

        </div>

        </>
    )
}
